export default function getStyles({ palette }) {
    const testConfigColors = {
        error: palette.support.supportError,
        success: palette.support.supportSuccess,
        default: palette.button.buttonPrimary,
    };

    return {
        formContainer: {
            height: '100%',
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            p: '16px',
            boxSizing: 'border-box',
            gap: '16px',
        },
        formTitle: {
            fontSize: '20px',
            fontWeight: 400,
        },
        firstFormBlock: {
            width: '50%',
            maxWidth: '50%',
            boxSizing: 'border-box',
            borderRight: '1px solid #f0f0f0',
            pr: '16px',
        },
        secondFormBlock: {
            width: '50%',
            maxWidth: '50%',
            boxSizing: 'border-box',
            borderLeft: '1px solid #f0f0f0',
            pl: '16px',
        },
        testConfiguration: status => ({
            width: 'fit-content',
            color: testConfigColors[status],
            fontSize: '14px',
            fontWeight: 500,
            cursor: 'pointer',
            pr: '16px',
        }),
    };
}
